import { Button, Stack, Text } from "@mantine/core";
import type { ReactNode } from "react";
import type { LoginTr } from "../useLoginTranslations";
import { AuthSplitLayout } from "./AuthSplitLayout";

export interface LoginDeactivatedViewProps {
  onChangeAccount: () => void;
  logo?: ReactNode;
  tr: LoginTr;
}

export function LoginDeactivatedView({ onChangeAccount, logo, tr }: LoginDeactivatedViewProps) {
  return (
    <AuthSplitLayout
      brandMode="deactivated"
      logo={logo}
      tr={tr}
      title={tr("login.deactivated.title", "Account deactivated")}
    >
      <Stack gap="md">
        <Text c="dimmed">
          {tr(
            "login.deactivated.message",
            "Your account has been deactivated. Please contact your administrator if you believe this is an error.",
          )}
        </Text>
        <Button onClick={onChangeAccount} fullWidth variant="outline">
          {tr("login.verifyEmail.changeAccount", "Sign in with a different account")}
        </Button>
      </Stack>
    </AuthSplitLayout>
  );
}
